import React, {useEffect, useState} from "react";
import PageContainer from "../../layouts/PageContainer";
import {helpers} from '../../helper/helper';
import {useCallback} from "react";
import UsersList from "./UsersList";
import Loader from "../../layouts/Loader";
import {useSnackbar} from "notistack";
import Swal from "sweetalert2";

const Users = () => {
    const {enqueueSnackbar} = useSnackbar();
    const [userList, setUserList] = useState();
    const [open, setOpen] = React.useState(false);
    const [openBlock, setOpenBlock] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    };
    const handleCloseBlock = () => {
        setOpenBlock(false);
    };

    const UsersData = useCallback(async () => {
        const url = "users/deleted/list/v1";
        const result = await helpers.apiCall('GET', url);
        setUserList(result.data.result.data);
    }, [setUserList]);

    const unDeleteUser = async (userId) => {
        try {
            const url = `users/un/delete/${userId}/v1`;
            const result = await helpers.apiCall('PUT', url, {});
            UsersData();
        } catch (error) {
            console.error("error", error);
        }
      };

    useEffect(() => {
        UsersData();
        setOpen(false);
        setOpenBlock(false)
    }, [UsersData]);

    const deleteGifts = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f50057",
            cancelButtonColor: "#263273",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.value) {
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
                const url = `users/${id}`;
                const result = await helpers.apiCall("DELETE", url);
                if (result.status === 200) {

                    UsersData();
                    enqueueSnackbar("User Deleted successfully", {
                        variant: 'success',
                        autoHideDuration: 3000,
                    });
                    handleClose()
                } else {
                    enqueueSnackbar(result.data ? result.data.message : result.message, {
                        variant: 'error',
                        autoHideDuration: 3000,
                    });
                }
            }
        });

    };

    const unDeleteUserConfirmation = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f50057",
            cancelButtonColor: "#263273",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.value) {
                unDeleteUser(id);
                enqueueSnackbar("User UnDeleted successfully", {
                    variant: 'success',
                    autoHideDuration: 3000,
                });
            }
        });

    };

    const BlockUser = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't to Block /Unblock ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f50057",
            cancelButtonColor: "#263273",
            confirmButtonText: "Yes",
        }).then(async (result) => {
            if (result.value) {
                Swal.fire("", "", "success");
                const url = `users/block/${id}`;
                const result = await helpers.apiCall("PUT", url);
                if (result.status === 200) {
                    handleCloseBlock();
                    UsersData();
                    enqueueSnackbar("User BLocked successfully", {
                        variant: 'success',
                        autoHideDuration: 3000,
                    });
                } else {
                    enqueueSnackbar(result.data ? result.data.message : result.message, {
                        variant: 'error',
                        autoHideDuration: 3000,
                    });
                }
            }
        });

    };
    return (
        <PageContainer pageheading="DELETED USER LIST">
            {!userList ? <Loader/> :
                <UsersList userList={userList} deleteGifts={deleteGifts} BlockUser={BlockUser} setOpen={setOpen}
                           setOpenBlock={setOpenBlock}
                           open={open}
                           handleClose={handleClose}
                           openBlock={openBlock}
                           unDeleteUserConfirmation={unDeleteUserConfirmation}
                           handleCloseBlock={handleCloseBlock}/>
            }
        </PageContainer>
    )
};
export default Users;